export default __webpack_public_path__ + "static/media/logoVashoWhite.37712862.png";